import React, { useContext, forwardRef, Ref } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import { Category } from './types';

type Props = {
  category: Category;
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
};

const CategoryLink = forwardRef(
  (
    { category, children, onClick, className }: Props,
    ref: Ref<HTMLAnchorElement>
  ) => {
    const { linkTo } = useContext(AppContext);

    if (category.external_uri) {
      return (
        <a
          onClick={onClick}
          className={className}
          href={category.external_uri}
          data-test="MegaMenuLink"
          data-test-id={category.id}
        >
          {children}
        </a>
      );
    }

    return (
      <Link
        onClick={onClick}
        className={className}
        to={linkTo('category', category)}
        innerRef={ref}
        data-test="MegaMenuLink"
        data-test-id={category.id}
      >
        {children}
      </Link>
    );
  }
);

export default CategoryLink;
